<script>
    import { fly } from "svelte/transition";

    // import Popup from "./Popup.svelte";
    import Navbar from "./Navbar.svelte";
    import Libro from "./Libro.svelte";
    import Error from "./Error.svelte";
    import Biografia from "./Biography.svelte";
    import Social from "./Social.svelte";
    // import Galery from "./Gallery.svelte";

    const animation = 1500;
    let first = true;

    let json;
    async function data() {
        first = false;
        json = json ? json : (await (await fetch('/data/libros.json')).json()).libros.reverse();
        return json;
    }

    let page = "inicio";
    let submenus = [
        { name: "Libros<br>para adultos", page: "inicio", html: true, },
        { name: "Libros<br>para peques", page: "lilah", html: true, },
        { name: "Libros<br>por peques", page: "isabella", html: true, },
        // { name: "Libros gratis<br>en Wattapp", page: "capitulos", html: true, },
        { name: "Biografías", page: "biografias", },
        // { name: "Galería", page: "galeria", },
    ];

    // const timeout = new Promise((resolve, reject) => {
    //     setTimeout(() => {
    //         resolve();
    //     }, 5000);
    // });
</script>

<!-- {#await timeout}
    <Popup/>
{/await} -->

<Navbar {submenus} bind:page></Navbar>

<!-- Main webpage -->
{#key page}
    {#await (new Promise(resolve => { setTimeout(resolve, animation); }))}
        {#if first}
            <p style="text-align: center;">Cargando página...</p>
        {/if}
    {:then i}
        <div class="main" in:fly={{ duration: animation, x: 200 }} out:fly={{ duration: animation, x: -200 }}>
            {#if page === "inicio" || page === "lilah" || page === "isabella" || page === "capitulos"}
                {#await data()}
                    <p>Cargando información del servidor...</p>
                {:then libros}
                    {#if libros.length}
                        {#each libros as libro}
                            {#if page === libro.page}
                                <div class="libro-object">
                                    <Libro {...libro}></Libro>
                                </div>
                            {/if}
                        {/each}
                    {:else}
                        <p>No hay libros a la venta</p>
                    {/if}
                {:catch err}
                    <Error/>
                    <p>Error al cargar la información del servidor:</p>
                    <p>{err}</p>
                {/await}
            {:else if page === "biografias"}
                <Biografia/>
            <!-- {:else if page === "galeria"}
                <Galery/> -->
            {:else}
                <h1>Page not found!</h1>
                <h2>404</h2>
            {/if}
        </div>
    {/await}
{/key}

<Social></Social>

<style>
    .main {
        text-align: center;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-evenly;
        align-content: center;
        align-items: baseline;
        margin: 12px;
    }

    .libro-object {
        height: auto;
        margin: 15px 3%;
        cursor: pointer;
    }

    @media (max-width: 628px) { /** One column */
        .libro-object {
            width: 80vw;
        }
    }

    @media (min-width: 629px) { /** More columns */
        .libro-object {
            width: 270px;
        }
    }
</style>
